import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import { Plus } from 'lucide-vue-next';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateButton',
  props: {
    buttonText: { default: 'tables.create' }
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: "ghost",
    width: "narrow",
    class: "self-start",
    size: "xs"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.buttonText)), 1),
      _createVNode(_unref(Plus), { class: "text-accent size-3.5" })
    ]),
    _: 1
  }))
}
}

})